export default function() {
    var video = document.querySelector('video#herovideo');
    if (video) {
        var visible = !!(video.offsetWidth || video.offsetHeight || video.getClientRects().length);
        if (visible) {
            var videoSources = document.querySelectorAll('video#herovideo source');
            for (var iVid = 0; iVid < videoSources.length; iVid++) {
                var datasrc = videoSources[iVid].getAttribute('data-src');
                videoSources[iVid].setAttribute('src', datasrc);
            }
            video.load();
        }
    }
}
